/** The doc's trash tab in the right sidebar. */
export const DOC_TRASH_SIDEBAR_TAB_ID = 'streamlain-doc-trash';
